<template>
    <div>

        <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="UsersIcon" :statistic="todayBookings" statisticTitle="Todays Token" :chartData="analyticsData.todayBooking" type='area' style="background:#8eefeb;"></statistics-card-line>
            </div>
           <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="DollarSignIcon" :statistic="monthBookings" statisticTitle="This Month Bookings" :chartData="analyticsData.monthBooking"  style="background: #f9f56a" color='success' type='area'></statistics-card-line>
            </div>-->
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="DollarSignIcon" :statistic="totalDoctors" statisticTitle="Total Doctors" :chartData="analyticsData.totalDoctorschart"  style="background: #f9f56a" color='success' type='area'></statistics-card-line>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="UsersIcon" :statistic="Doctoravailable" statisticTitle="Available Doctors" :chartData="analyticsData.availableDoctor" style="background: #ffb85e" color='danger' type='area'></statistics-card-line>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="ShoppingBagIcon" :statistic="OP" statisticTitle="Todays OP" :chartData="analyticsData.todayOP" style="background:rgb(255, 86, 86)" color='warning' type='area'></statistics-card-line>
            </div>
        </div>
		<div class="vx-row">
            <div class="vx-col w-full md:w-1/2">
            <vx-card title="Today's Appointments" class="mb-base">
                <div class="mt-5">
                    <chartjs-component-bar-chart   v-if="loaded" :height=250 :data="data" :options="options"></chartjs-component-bar-chart>
                </div>
            </vx-card> 
            </div>

            <div class="vx-col w-full md:w-1/2">
                <vx-card title="Current Activities" class="mb-base" style="height:92%">
                   
                 <vs-table :data="currentActivity">

                    <template slot="thead">
                    <vs-th>SrNo</vs-th>
                    <vs-th>PhoneNo</vs-th>
                    <vs-th>Status</vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        
                        <vs-td>
                        {{ indextr+1}}
                        </vs-td>

                        <vs-td :data="data[indextr].phoneNo">
                        {{ data[indextr].phoneNo }}
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                        {{ data[indextr].status }}
                        </vs-td>

                    </vs-tr>
                    </template>

                </vs-table>
                </vx-card>
            </div> 
        </div>
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ChartjsComponentBarChart from "@/components/ChartjsComponentBarChart.vue"

export default{
       extends: Bar,
    components:{
        StatisticsCardLine,ChartjsComponentBarChart
    },
    
    data() {
        return {
            todayBookings:"",
            //monthBookings:"",
            Doctoravailable:"",
            OP:"",
            totalDoctors:"",
            analyticsData: {
                todayBooking:[{
                    name:"book",
                    data:[this.todayBookings]
                }],
                /*monthBooking:[{
                    name:"month",
                    data:[this.monthBookings]
                }],*/
                availableDoctor:[{
                    name:"doctor",
                    data:[this.Doctoravailable]
                }],
                todayOP:[{
                    name:"op",
                    data:[this.OP]
                }] ,
                totalDoctorschart:[{
                    name:"doctors",
                    data:[this.totalDoctors]}]
            },
     chartData:"",
     loaded:false,
     data:{},
     options:{},
     currentActivity:[]
  
    }
  },
    beforeMount() {
        this.display();
        this.chartDispaly();
       
    },
    created(){
    this.interval = setInterval(() => this.statusTable(), 1000);
    },
   beforeDestroy: function(){
    clearInterval(this.interval);
    },
    methods:{
        display:function(){
            var request={companyId :this.$session.get('companyId')};
            this.$http.post(
                 'dashboardstats',
                JSON.stringify(request),{
                    headers: {
                    "Content-Type": "application/json"
                    }
                }
            )
             .then(response => {
               console.log("overview data",response.data)
                     this.todayBookings = response.data.data.todayBooking;
                     //this.monthBookings = response.data.data.monthBooking;
                     this.Doctoravailable = response.data.data.availableDoctor;
                     this.OP = response.data.data.todayOP;
                     this.totalDoctors=response.data.data.totalDoctors;
                     
                });
        },
        chartDispaly(){
            var request={companyId :this.$session.get('companyId')};
            this.$http.post(
                "chartresource",
                JSON.stringify(request),{
                    headers: {
                    "Content-Type": "application/json"
                    }
                }
            )
            .then(response => {
                 this.data={
                        labels:response.data.data.label,
                        datasets: [{
                        label: "Today's Appointments",
                        backgroundColor: ["#3e95cd", "#8e5ea2", "#3cba9f", "#e8c3b9", "#c45850", "#c45850"],
                        data: response.data.data.data
                            }]
                        },
                this.options={
                    legend: { display: false },
                    title: {
                    display: true,
                    text: "Today's Appointments"
                    }
                }
                this.loaded = true        
                });
            },
       statusTable(){
            var request={companyId :this.$session.get('companyId')};
            this.$http.post(
                "checkactivities",
                JSON.stringify(request),{
                    headers: {
                    "Content-Type": "application/json"
                    }
                }
            )
            .then(response => {
                this.currentActivity=response.data.data;
            });
        }
   
    }
    
}
</script>

